import { accentColor, primaryColor } from '../locatorDriftConstants';

export const historyStyles = {
  metaRow: {
    flex: 'column',
    gap: 2,
  },
  loader: {
    color: accentColor,
  },
  item: (active) => ({
    p: 1.5,
    m: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    cursor: 'pointer',
    borderColor: active ? primaryColor : undefined,
    bgcolor: active ? '#F7F8FA' : '#fff',
    '&:hover': { borderColor: primaryColor },
  }),
  itemContent: {
    minWidth: 0,
    flex: 1,
  },
};
